import { connect } from 'react-redux'
import RiderProfileCreatePane from '../../components/riders/createrider/RiderProfileCreatePane'
import { createRider, actionCreators as riderActionCreators } from '../../state/actions/riders'
import { IRiderObject, IStoreState } from '../../types'
import { actionCreators } from '../../state/actions/organizations'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    metadata: state.riders.metadata,
    rider: state.riders.riderSavedId === '-1' ? state.riders.rider : state.riders.items[state.riders.riderSavedId],
    organizations: state.organizations.items,
    organizationsFetchingMetaData: state.organizations.metadata,
    currentOrgId: state.organizations.currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveRider: (rider: IRiderObject): any => {
      return dispatch(createRider(rider))
    },
    getAllAvailableOrganizations: (): any => {
      return dispatch(actionCreators.fetchOrganizationsRequest())
    },
    clear: (): any => {
      return dispatch(riderActionCreators.clearRiderCreate())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderProfileCreatePane)



// WEBPACK FOOTER //
// ./src/containers/riders/RiderProfileCreatePane.ts